//import axios from "axios";
export default {
    state: {
        categories: []
    },
    actions: {
        async getCategories(ctx) {
           /* let res = await axios.get('categories', {
                params: {
                    'filters[id]': 37,
                }
            })*/
            ctx.commit('setCategories', [
                {
                    "id": 37,
                    "title": "Русский язык",
                    "icon": "russkiy-yazyk"
                },
            ])
        }
    },
    mutations: {
        setCategories(state, categories) {
            state.categories = categories
        }
    },
    getters: {
        allCategories(state) {
            return state.categories
        }
    }
}